import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationHE from './locales/he/translation.json';
import translationPT from './locales/pt/translation.json';

const resources = {
  en: { translation: translationEN },
  he: { translation: translationHE },
  pt: { translation: translationPT }
};

// Load saved language from localStorage
const savedLanguage = localStorage.getItem('language');
const defaultLanguage = savedLanguage || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage, // Use saved language or default to 'en'
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;